/**
 * @file コンポーネント：リストトグルアイテム ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const ListItemToggle = (props) => {
    /**
     * トグル開閉状態管理
     */
    const [isOpen, setIsOpen] = useState(props.isOpen);
    // 親コンポーネントから渡される値の変更を反映
    useEffect(() => {
        setIsOpen(props.isOpen);
    }, [props.isOpen]);

    // Presenterに渡す
    return <Presenter {...props} isOpen={isOpen} setIsOpen={setIsOpen} />;
};
